import { StoreService } from "./StoreService";
export { StoreService };
